<img class="mobile-hide menu-bg" [src]="commonService.resource.image.menu_bg_desk" alt="">
<div class="app-container">
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0 about-container">
            <div class="menu-header menu-header-content py-3 px-4">
                <div class="py-3">
                    <span class="material-icons-outlined cursor" (click)="commonService.goBack()">
                    arrow_back
                </span>
                </div>
                <div class="">{{ "changeLanguage.title" | translate}}</div>
            </div>
        </div>
        <div class="col-md-5 col-sm-12 p-0 about-container">
            <div class="mt-2 overflow-auto about-content">
                <div class="mx-4  about-container">
                    <div class="app-sub-heading mb-4">
                        {{ 'changeLanguage.language' | translate}}
                    </div>
                    <div class="d-flex justify-content-between gap-3">
                        <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'en' }" (click)="setLanguage('en')">
                            {{ 'setLanguage.language1' | translate}}
                        </button>
                        <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'ma' }" (click)="setLanguage('ma')">
                            {{ 'setLanguage.language2' | translate}}
                        </button>
                        <button mat-button class="landing-page-btn" [ngClass]="{ 'active': language === 'hi' }" (click)="setLanguage('hi')">
                            {{ 'setLanguage.language3' | translate}}
                        </button>
                    </div>
                    <div class="py-5">
                        <button mat-button class="primary-button w-100" (click)="commonService.saveLanguage(language, '/menu')">
                            {{ 'setLanguage.setLanguageBtn' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2 p-0"></div>
    </div>
</div>